import { FormProvider, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { OrderData } from 'support/helpers/orderForms/orderForms';
import { OrderFormCategoryDTO } from 'support/types/dtos';

import { Form } from 'components/Form/Form';

import { OrderFormCategory } from '../OrderFormCategory/OrderFormCategory';

type OrderFormContentProps = {
  categories: Array<OrderFormCategoryDTO>;
  formMethods: UseFormReturn<OrderData>;
  partnerName?: string;
  className?: string;
};

export const OrderFormContent = ({
  categories,
  formMethods,
  partnerName = 'Your Company',
  className,
}: OrderFormContentProps) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <div>
        <h1 className="text-2xl font-extrabold text-gray-900">
          {t('orderForms:form.title', { userPartnerName: partnerName })}
        </h1>
        <h2 className="text-2xl font-medium text-gray-500">{t('orderForms:form.subtitle')}</h2>
      </div>
      <FormProvider {...formMethods}>
        <Form className="flex-1">
          {categories.map((category) => (
            <OrderFormCategory key={category.name} category={category} />
          ))}
        </Form>
      </FormProvider>
    </div>
  );
};
